// Shared active-tenant source for capture-ui (2026-06-05 tenant-resolution fix,
// ruling R1/R4). ONE pluggable source: today an in-app value (module state +
// localStorage); if per-tenant subdomains/paths are adopted later, only this
// module changes — the x-tenant-id attach in api.js stays identical.

const STORAGE_KEY = 'capture_active_tenant_id';

let activeTenantId = null;
try {
  activeTenantId = (typeof localStorage !== 'undefined' && localStorage.getItem(STORAGE_KEY)) || null;
} catch {
  activeTenantId = null;
}

export function getActiveTenantId() {
  return activeTenantId;
}

export function setActiveTenantId(id) {
  activeTenantId = id || null;
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* non-fatal */
  }
  // Let interested components (switcher) react.
  try {
    window.dispatchEvent(new CustomEvent('capture:active-tenant-changed', { detail: { tenantId: activeTenantId } }));
  } catch {
    /* SSR / no window */
  }
}

export const TENANT_SELECTION_REQUIRED_EVENT = 'capture:tenant-selection-required';
